module.exports = __webpack_public_path__ + "static/media/Layout8.8dcd8cb4.png";